<div class="warning-popup" *ngIf="Texts && !Texts.closed" >
  <div class="warning-icon">
    <i class="fa fa-exclamation-triangle"></i>
  </div>

  <div class="warning-content">
    <strong>{{ Texts.title }}</strong>
    <span>
      {{Texts.message}}
    </span>
  </div>

  <button *ngIf="Texts.closable" (click)="Texts.closed = true"
    type="button"
    class="warning-close"
    aria-label="Chiudi">
    &times;
  </button>
</div>
<div style="margin-bottom: 30px" *ngIf="Texts && !Texts.closed"></div>
